export default __webpack_public_path__ + "static/media/78.cb5ecb1d.gif";